import * as React from "react";
import {
    UitkCardContentSection,
    UitkIconSize,
    UitkLayoutFlexItem,
    UitkText,
    UitkCard,
    UitkHeading,
    UitkIcon,
    UitkLayoutFlex,
    UitkSpacing
} from "@egencia/uitk-react";
import {useState, useEffect, useRef} from 'react'
import {ArticleDetails} from "./article-details";
import {getUitkReactIconNameFromTopic} from "../common/utilities";
import {NoSearchResults} from "./no-search-results";

function ArticleTitle({ article, isAlert, onToggle, toggled }) {
    return (
            <UitkLayoutFlex space="two" className="article-title" onClick={onToggle} style={{ cursor: 'pointer' }}>
                <UitkLayoutFlexItem>
                    <UitkSpacing padding={{inlineend: "two"}}>
                        <UitkIcon name={toggled ? 'expand_less' : 'expand_more'}/>
                    </UitkSpacing>
                </UitkLayoutFlexItem>
                <UitkLayoutFlexItem>
                    <UitkText size={400}>
                        {isAlert && (
                            <UitkSpacing padding={{inlineend: "two"}}>
                                <UitkIcon name='warning'/>
                            </UitkSpacing>
                        )}
                        <span dangerouslySetInnerHTML={{__html: article.title}}></span>
                    </UitkText>
                </UitkLayoutFlexItem>
            </UitkLayoutFlex>
    )
}

function ArticleGroup({ title, topic, articles, isAlerts, className }) {
    const [articleToggles, setArticleToggles] = useState(articles.map(a => false));
    const pageLoading = useRef(true);
    
    useEffect(() => {
        if (pageLoading.current) {
            pageLoading.current = false
        } else {
            window.convertWistiaTagsToEmbedScripts(false);
        }
    }, [articleToggles]);
    
    function onExpandoToggle(article, i) {
        const isOpeningArticle = !articleToggles[i];
        const {title, isFaq} = article;

        // simplified version of the faq/alert + expand/collapse
        const omintureTitle = title.replace(/\?/g, '').split(' ').join('.');
        const articleTypeString = isFaq ? 'FaqContent' : 'AlertContent';
        const actionString = isOpeningArticle ? 'Expand' : 'Collapse';
        //tagPrefix will remove "page."
        const tagPrefix = EG.pageName.replace('page.', '');
        omnitureLog.logClickEvent(tagPrefix + `.${articleTypeString}.${actionString}.` + omintureTitle);

        // update toggle state
        const newArticleToggles = [...articleToggles];
        newArticleToggles[i] = isOpeningArticle;
        setArticleToggles(newArticleToggles);
    }
    
    return (
        <UitkCard className={className} border={true}>
            <UitkSpacing margin={{blockstart:"four"}}>
                {title && (
                    <UitkSpacing margin="four">
                        <UitkHeading tag="h2" size={5}>
                            {topic && (
                                <UitkSpacing padding={{inlineend: "two"}}>
                                    <UitkIcon name={getUitkReactIconNameFromTopic(topic)} size={UitkIconSize.SMALL}/>
                                </UitkSpacing>
                            )}
                            {title}
                        </UitkHeading>
                    </UitkSpacing>
                )}
                
                {articles.map((article, i) => (
                    <UitkCardContentSection key={i} border="top">
                        <ArticleTitle article={article} isAlert={isAlerts} onToggle={() => onExpandoToggle(article, i)} toggled={articleToggles[i]}/>
                        {articleToggles[i] && (
                            <ArticleDetails article={article} topic={topic}/>
                        )}
                    </UitkCardContentSection>
                ))}
            </UitkSpacing>
        </UitkCard>
    )
}

export const CategorizedArticles = ({articleGroups}) => {
    const articleCount = articleGroups.reduce((sum, num) => { sum += num.articles?.length ?? 0; return sum; }, 0);

    return (
        <>
            {articleCount ? (
                <>
                    {articleGroups
                        .filter(articleGroup => articleGroup.articles?.length)
                        .map((articleGroup, i) =>
                            <ArticleGroup key={i} {...articleGroup} />
                        )
                    }
                </>
            ) : (
              <NoSearchResults />  
            )}
        </>
    )
}